import { IFiltersMeta } from '../../types/filters';
import { IApplicationState } from '../../types/redux';

export const selectFiltersMeta = (state: IApplicationState): IFiltersMeta => {
  return state.filters.meta;
};
